import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import MediaQuery from 'react-responsive';
import MonitorsModal from './MonitorsModal';
import StepSlider from './StepSlider';
import ScaleSettings from './ScaleSettings';
import DomainSettings from './DomainSettings';
import { styles } from '../../styles/form-styles';
import { updateDataMapContainer } from './utils/updateDataMapContainer';

class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      checkboxes: [],
      allChecked: true,
    }
    this.toggleChecked = this.toggleChecked.bind(this);
  }

  toggleChecked = index => event => {
    const checkboxes = this.state.checkboxes;
      checkboxes[index].checked = event.target.checked;
    let allChecked = true;
    for(let i=0; i<checkboxes.length; i++) {
      if(!checkboxes[i].checked) {
        allChecked = false;
      }
    }
    this.setState({
      checkboxes,
      allChecked
    })
  }
  handleSelectAll = () => {
    const allChecked = event.target.checked;
    const checkboxes = this.state.checkboxes;
    checkboxes.forEach(checkbox => {
      checkbox.checked = allChecked
    })
    this.setState({
      checkboxes,
      allChecked,
    })
  }

  setCheckboxes = (data) => {
    const checkboxes = data.map((map, index) => {
      const { id, friendlyName, checked } = map.monitor;
      return {
        id,
        friendlyName,
        checked,
      }
    })
    this.setState({
      checkboxes,
    })
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  componentDidMount() {
    this.setCheckboxes(this.props.dataMapContainer);
  };

  componentWillReceiveProps(nextProps) {
    if(this.props.dataMapContainer != nextProps.dataMapContainer) {
      this.setCheckboxes(nextProps.dataMapContainer);
    }
  };

  render() {
    const colSliderActive = this.props.layout === "grid" ? true : false;
    const { classes } = this.props;
    return(
      <div className={classes.root}>
        <form className={classes.form} noValidate>
          <MonitorsModal
            checkboxes={this.state.checkboxes}
            dataMapContainer={this.props.dataMapContainer}
            onSiteChange={this.props.onSiteChange}
            toggleChecked={this.toggleChecked}
            allChecked={this.state.allChecked}
            handleSelectAll={this.handleSelectAll}
            updateDataMapContainer={updateDataMapContainer}
          />
          <MediaQuery query='(min-device-width: 1024px)'>
            <InputLabel className={classes.inputLabel} htmlFor="layout">Layout:</InputLabel>
            <RadioGroup
              aria-label="layout"
              name="layout"
              className={classes.group}
              value={this.props.layout}
              onChange={this.props.onChange}
            >
              <FormControlLabel value="list" control={<Radio />} label="List" />
              <FormControlLabel value="grid" control={<Radio />} label="Grid" />
              <StepSlider cols={this.props.cols} onChange={this.props.onChange} active={colSliderActive}/>
              <FormControlLabel value="slideshow" control={<Radio />} label="Slideshow" />
            </RadioGroup>
          </MediaQuery>
          <FormGroup row>
        <InputLabel className={classes.inputLabel} htmlFor="rangeSetting">Data Range: </InputLabel>
          <Select
          className={classes.select}
          value={this.props.rangeSetting}
          onChange={this.props.onChange}
          inputProps={{
            name: 'rangeSetting',
            id: 'rangeSetting',
          }}

          >
          <MenuItem value={this.props.rangeSetting}>
            <em>Select...</em>
          </MenuItem>
          <MenuItem value={21600}>past 6 hours</MenuItem>
          <MenuItem value={43200}>past 12 hours</MenuItem>
          <MenuItem value={86400}>past 24 hours</MenuItem>
          <MenuItem value="custom" disabled>Custom range</MenuItem>
          </Select>
          </FormGroup>
          <InputLabel className={classes.inputLabel} htmlFor="refreshRate">Refresh rate:</InputLabel>
          <RadioGroup row
            aria-label="refresh rate"
            name="refreshRate"
            className={classes.group}
            value={this.props.refreshRate}
            onChange={this.props.onChange}
          >
            <FormControlLabel value="60" control={<Radio />} label="60 secs" />
            <FormControlLabel value="300" control={<Radio />} label="5 mins" />
            <FormControlLabel value="600" control={<Radio />} label="10 mins" />
          </RadioGroup>
          <ScaleSettings scale={this.props.scale} onChange={this.props.onChange}/>
          <DomainSettings domainMin={this.props.domainMin} domainMax={this.props.domainMax} onChange={this.props.onChange} scale={this.props.scale} />
        </form>
      </div>
    )
  }
}

Settings.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Settings);



// WEBPACK FOOTER //
// ./src/components/Settings/Settings.js